import Container from '@mui/material/Container/Container';
import Stack from '@mui/material/Stack/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export const PageContainer = ({
    className,
    sx,
    spacing,
    breadcrumbs,
    children
}: {
    className?: string
    sx?: SxProps<Theme>
    spacing?: number
    breadcrumbs?: ReactNode
    children: ReactNode
}) => {
    return (
        <Container className={className}
            sx={{ backgroundColor: 'background.default', color: 'text.primary', paddingBottom: 4, margin: 'auto', ...sx }}>
            {
                spacing ? <Stack direction="column" spacing={2} mb={3}>
                    {breadcrumbs}
                    {children}
                </Stack> : <>
                    {breadcrumbs}
                    {children}
                </>
            }
        </Container>
    );
};
